import type React from 'react';
import { EmailSentScreen, type EmailSentScreenProps } from '../email-sent-screen';

export interface ResetEmailSentScreenProps extends Omit<EmailSentScreenProps, 'children'> {
  /** The address the reset link was requested for. */
  email: string;
}

/**
 * "Check your email" after a reset request. Worded the same whether or not the address has an account, so it
 * never reveals which.
 */
export const ResetEmailSentScreen: React.FC<ResetEmailSentScreenProps> = ({ email, ...props }) => (
  <EmailSentScreen {...props}>
    <p>
      If there's an account for <strong>{email}</strong>, we've sent a link to reset your password.
    </p>
  </EmailSentScreen>
);
